import {Link} from "@material-ui/core";
import React, {MouseEvent, ReactNode} from "react";
import {LOGIN_PATH} from "view/routes";

type Props = {
  children?: ReactNode;
  onClick?: () => void;
};

const LoginLink = ({children = "Sign In", onClick}: Props) => {
  const handleClick = onClick
    ? (event: MouseEvent) => {
        event.preventDefault();
        onClick();
      }
    : undefined;

  return (
    <Link
      href={LOGIN_PATH}
      onClick={handleClick}
      color="primary"
      variant="h4"
      style={{textDecoration: "underline", fontWeight: 500}}
    >
      {children}
    </Link>
  );
};
export default LoginLink;
